import * as enums from '@/common/helpers/enums'

export default enums.fromObjects({
    '区分マンション': {
        value: 'condo',
        extra: [
            'building.name',
            'building.address',
            'roomNumber',
            'floor',
            'building.floorsCount',
            'building.structure',
            'dealPrice',
            'sqm',
            'floorPlan',
            'building.builtAt'
        ]
    },
    '戸建': {
        value: 'house',
        extra: [
            'building.address',
            'dealPrice',
            'landSqm',
            'sqm',
            'floorPlan',
            'building.builtAt'
        ]
    },
    '土地': {
        value: 'land',
        extra: [
            'building.address',
            'dealPrice',
            'landSqm'
        ]
    }
})
